import React, { ReactNode } from 'react';
import Header from './Header';
import styles from './contentLayout.module.scss';
import Background from '../../assets/connect-bg.png';
import { LOADING_BACKGROUND_COLOR } from '../../constants/styling';
import { useSettings } from '../../hooks/queryHooks';
import { AttoLogo } from '../../resources/img/atto-logo';
import Sidebar from './Sidebar';
import Loader from '../loader/Loader';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { islightColor } from '../../utils/ColorHelper';

const ContentLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { settings, isSettingsLoading } = useSettings();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const isSidebarDisabled = pathname.includes('/error');

  if (isSettingsLoading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <Loader display={true} spinnerText={t('Loading...')} />
      </div>
    );
  }

  const customBgColor = settings?.customColors?.backgroundColor;
  const isLightBackground = customBgColor ? islightColor(customBgColor) : null;

  return (
    <div
      className={styles.pageContainer}
      style={{
        backgroundColor: isSettingsLoading ? LOADING_BACKGROUND_COLOR : customBgColor,
        backgroundImage: !customBgColor ? `url(${Background})` : ''
      }}
    >
      <Header />
      <div
        className={`${styles.outerContainer} min-h-auto sm:min-h-[700px] h-full sm:h-auto flex shadow-xl rounded-2xl`}
      >
        <div
          className={`
          ${styles.innerContent} rounded-2xl ${
            isSidebarDisabled ? 'max-w-full' : 'xl:rounded-tr-none sm:max-w-[1280px] xl:rounded-br-none'
          }
           xl:max-w-full lg:rounded-tl-2xl lg:rounded-bl-2xl grow min-w-0 h-full sm:h-auto p-0 sm:p-10`}
        >
          {children}
        </div>
        {!isSidebarDisabled && <Sidebar />}
      </div>
      <footer
        className={`hidden sm:flex w-full justify-center mb-2 ${
          isLightBackground != null && (isLightBackground === true ? 'text-primary-2' : 'text-white')
        }`}
      >
        {t('Powered by')}{' '}
        {settings?.directIDLogoUrl ? (
          <img src={settings?.directIDLogoUrl} alt="Atto Logo" className="h-6 w-16 mx-4" />
        ) : (
          <AttoLogo className="h-6 w-16 mx-4" />
        )}{' '}
        &copy; {new Date().toLocaleDateString(navigator.language, { year: 'numeric' })}
      </footer>
    </div>
  );
};

export default ContentLayout;
